import CircleContainer from './circle-container';
import Container from '@/components/Container';
import Divider from '@/components/Divider';
import PageHeader from '@/components/PageHeader';
import { renderCards } from '../knowledge-hub/main';

import EmotionWheelSkeleton from './loading/EmotionWheel.skeleton';
import { useEmotionWheel } from './hooks/useEmotionWheel';
import { MessageContainer } from './message-container';
import { useEmotionWheelStore } from './store/useEmotionWheelStore';
import { useAuthentication } from '@/hooks/useAuthentication';
import GenericOnboarding from '@/components/generic-onboarding';
import { onChangeOnboardStatus } from '@/services/daily/emotion-wheel.service';
import { ResetWheelButton } from './reset-wheel-button';
import { ProfileEmotionWheelTrackingCalendar } from '../profile/EmotionWheelTrackingCalendar';

export default function EmotionalWheelPage() {
  const { emotionWheelpage, loading, L2, L1 } = useEmotionWheelStore();
  const { youMayAlso } = useEmotionWheel();
  const { authentication, setAuthentication } = useAuthentication();

  const renderContent = () => {
    if (!authentication.user.onboardEmotionWheelCompleted) {
      return (
        <GenericOnboarding
          onboarding={emotionWheelpage?.onboarding}
          onFinish={async () => {
            await onChangeOnboardStatus();
            setAuthentication({
              ...authentication,
              user: {
                ...authentication.user,
                onboardEmotionWheelCompleted: !authentication.user.onboardEmotionWheelCompleted,
              },
            });
          }}
        />
      );
    }

    return (
      <div className="col-span-12 gap-4 lg:col-start-3 lg:col-end-11">
        <div>
          {!loading && (
            <div className="grid grid-cols-1 md:mb-8 xl:min-h-[500px] xl:grid-cols-8">
              <>
                <div className="col-span-5 mr-sh-30 flex items-center justify-center  ">
                  <MessageContainer />
                </div>
                <div className="col-span-3 mt-sh-30 flex items-center justify-center md:mt-0 xl:justify-start">
                  <CircleContainer />
                </div>
                <ResetWheelButton show={!!L1! && !L2} onlyMobile />
              </>
            </div>
          )}

          {L2 && <ProfileEmotionWheelTrackingCalendar isEmotionWheelPage />}

          <ResetWheelButton show={!!L2} forceShow />
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-[46rem]">
      <Container className="mt-sh-60">
        <div className="col-span-12 gap-4 lg:col-start-3 lg:col-end-11">
          <PageHeader title="Emotion Wheel" url="/" type="emotion" />
        </div>

        {renderContent()}

        <div className="col-span-12 gap-4 lg:col-start-3 lg:col-end-11">
          <div>
            {loading && <EmotionWheelSkeleton />}

            {emotionWheelpage?.messages && <Divider />}

            <div className={youMayAlso.length > 0 ? 'mt-sh-30' : ''}>
              {renderCards({
                title: emotionWheelpage?.relatedContentTitle || 'You may also like',
                data: youMayAlso,
                showDivider: false,
                viewAll: true,
                viewAllText: emotionWheelpage?.relatedContentViewAllLabel || 'View All',
              })}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}
